import {
    LOGIN,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
} from '../action/loginAction'
import { api_err_msg } from "../strings.json"

const initialState = {
    apiState: "", // loading, success, error
    message: "",
    data: {},
}

export default function (state = initialState, action) {
    switch (action.type) {
        case LOGIN:
            return {
                ...state,
                apiState: "loading",
            }

        case LOGIN_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data,
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }

        case LOGIN_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response.data.message
            }

        default:
            return state
    }
}
